import { render } from "./BooleanInput.vue?vue&type=template&id=04869ad2"
import script from "./BooleanInput.vue?vue&type=script&lang=js"
export * from "./BooleanInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__